__webpack_require__.p = "/hackathon/2023/";